import { useState } from "react";
import { Link } from "react-router-dom";
import { useConsent } from "../../hooks/useConsent";
import "./CookieBanner.css";

function CookieBanner() {
  const { consent, hasDecision, acceptAll, rejectAll, saveConsent } = useConsent();
  const [open, setOpen] = useState(false);

  // Banner nur vor erster Entscheidung anzeigen
  if (hasDecision) return null;

  return (
    <div className="cookie-banner-wrap">
      <div className="cookie-banner-panel hover-lift">
        <div className="cookie-banner-copy">
          <h3>Cookies & Tracking</h3>
          <p>
            Wir nutzen notwendige Cookies für Grundfunktionen. Statistik- und Marketing-Technologien
            setzen wir nur nach deiner Einwilligung ein. Details findest du in unserer{" "}
            <Link to="/datenschutz">Datenschutzerklärung</Link>.
          </p>
        </div>

        <div className="cookie-banner-actions">
          <button className="btn cookie-btn" type="button" onClick={acceptAll}>
            Alle akzeptieren
          </button>
          <button className="cookie-link" type="button" onClick={rejectAll}>
            Ablehnen
          </button>
          <button className="cookie-link" type="button" onClick={() => setOpen(v => !v)}>
            Einstellungen
          </button>
        </div>

        <div className={"cookie-settings" + (open ? " is-open" : "")}>
          {/* Notwendig */}
          <div className="cookie-settings-row">
            <div className="cookie-settings-label">
              <span className="cookie-settings-title">Notwendig</span>
              <span className="cookie-settings-sub">Für Grundfunktionen (immer aktiv)</span>
            </div>
            <div className="cookie-toggle is-on is-locked" aria-hidden="true">
              <span className="cookie-toggle-dot" />
            </div>
          </div>

          {/* Statistik */}
          <div className="cookie-settings-row">
            <div className="cookie-settings-label">
              <span className="cookie-settings-title">Statistik</span>
              <span className="cookie-settings-sub">Auswertung zur Optimierung</span>
            </div>
            <button
              type="button"
              className={"cookie-toggle" + (consent.analytics ? " is-on" : "")}
              onClick={() =>
                saveConsent({
                  analytics: !consent.analytics,
                  marketing: consent.marketing,
                })
              }
              aria-pressed={consent.analytics}
            >
              <span className="cookie-toggle-dot" />
            </button>
          </div>

          {/* Marketing */}
          <div className="cookie-settings-row">
            <div className="cookie-settings-label">
              <span className="cookie-settings-title">Marketing</span>
              <span className="cookie-settings-sub">Google Ads Conversion-Tracking</span>
            </div>
            <button
              type="button"
              className={"cookie-toggle" + (consent.marketing ? " is-on" : "")}
              onClick={() =>
                saveConsent({
                  analytics: consent.analytics,
                  marketing: !consent.marketing,
                })
              }
              aria-pressed={consent.marketing}
            >
              <span className="cookie-toggle-dot" />
            </button>
          </div>

          <div className="cookie-settings-save">
            <button className="btn cookie-btn" type="button" onClick={acceptAll}>
              Auswahl speichern
            </button>
            <button className="cookie-link" type="button" onClick={rejectAll}>
              Alles ablehnen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
